import styles from './index.module.scss'

const Line = ({num,title,text,active,finished}) => {
   return (
         <div className={styles.step}>
            {!(num===1)?<div 
             style={{backgroundColor:active?'#00D68F':finished?'#00D68F':null}}
             className={styles.line} />:null}
            <span
            style={{backgroundColor:active?'#166FE5':finished?'#00D68F':null}}>{num}</span>
            <div className={styles.text}>
               <h3>{title}</h3>
               <p>{text}</p>
            </div>
         </div>
   )
}

export default Line